"use client";
import { TuneIdentifier } from '../../views/TuneIdentifier';

export default function Page() {
  return <TuneIdentifier />;
}
